import { useEffect, useState } from "react";

interface StickyOptions {
    targetRef: React.RefObject<HTMLElement>;
    offset?: number;  // Optional offset from the top for the sticky effect
}
const useGlobalStickyOnView = ({ targetRef, offset = 0 }: StickyOptions) => {
    const [initialPosition, setInitialPosition] = useState(0);

    useEffect(() => {
        const target = targetRef?.current;
        if (!target) { return }

        // Create a placeholder element
        const placeholder = document.createElement("div");
        placeholder.style.width = `${target.offsetWidth}px`;
        placeholder.style.height = `${target.offsetHeight}px`;
        placeholder.style.display = "none";
        target.parentNode?.insertBefore(placeholder, target);

        // Set the initial position of the target element
        const initialRect = target.getBoundingClientRect();
        const position = initialRect.top + window.scrollY;
        setInitialPosition(position);

        const handleScroll = (customInitialPosition?: number) => {

            const elementPosition = customInitialPosition || initialPosition;
            // debugger;
            const scrollPosition = window.scrollY;
            if (scrollPosition + offset >= elementPosition) {
                target.style.position = "fixed";
                target.style.top = `${offset}px`;
                placeholder.style.display = "block";
            } else {
                target.style.position = "relative";
                target.style.top = "0px";
                placeholder.style.display = "none";
            }
        };
        // Perform an initial check
        handleScroll(position)
        window.addEventListener("scroll", () => handleScroll());
        return () => {
            window.removeEventListener("scroll", () => handleScroll());
            placeholder.remove();
        }
    }, [targetRef, offset, initialPosition]);
};

export default useGlobalStickyOnView;
